function time2obj(inputTime) {
    var date = new Date(inputTime)
    var y = date.getFullYear()
    var m = date.getMonth() + 1
    m = m < 10 ? ('0' + m) : m
    var d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    var h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    var minute = date.getMinutes()
    var second = date.getSeconds()
    minute = minute < 10 ? ('0' + minute) : minute
    second = second < 10 ? ('0' + second) : second
    return {
        y: y, m: m, d: d, h: h, minute: minute, second: second
    }
}

export function Time(inputTime) {
    var t = new Date().getTime() - inputTime * 1000
    if (t <= 0) return 'now'
    var day = Math.floor(t/(24*60*60*1000))
    t = t%(24*60*60*1000)
    var h = Math.floor(t/(3600*1000))
    t = t%(3600*1000)
    var min = Math.floor(t/(60*1000))
    if (Math.floor(day / 365)) return `${Math.floor(day / 365)}y`
    if (Math.floor(day / 30)) return `${Math.floor(day > 30)}m`
    if (day <= 30 && day > 0) return `${day}d`
    if (h) return `${h}h`
    if (min) return `${min}minute`
    return 'now'
}

export function OnlyText(value) {
    let v = value.replace(/<[^>]+>/g,"")
    return v
}


// WEBPACK FOOTER //
// ./src/filter/index.js